import React, { useState } from "react";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import Illustration from "../../../../../partials/content/Illustration";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import ResponsiveEllipsis from "../../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import _ from "lodash";
import { useFormikContext } from "formik";
import { FormArrayTextField } from "../../../../../partials/content/Forms/FormField";
import ItemSellVarDetailForm from "./ItemSellVarDetailForm";

function ItemSellFormContent({
  outlet = { ID: 0, currency: { currencyCode: "" } },
  history,
  onReloadItemsSellingPrice,
}) {
  const { values, handleSubmit } = useFormikContext();
  const [selectedItem, setSelectedItem] = useState({
    ID: 0,
    outletID: 0,
    itemID: 0,
    item: { itemName: "", uomID: 0, itemUom: { uomName: "" } },
  });
  const [openItemVariants, setOpenItemVariants] = useState(false);

  const itemSellDetailColumn = [
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <React.Fragment>
      {values.data.length ? (
        <CustomDataTable
          data={values.data}
          dataDetailColumns={itemSellDetailColumn}
          onRefreshData={() => {
            onReloadItemsSellingPrice();
          }}
          buttons={[
            {
              name: "Save",
              onClick: (e) => {
                handleSubmit(e);
              },
              icon: "fas fa-save",
              color: "success",
            },
          ]}
          columns={[
            {
              header: "Item ID",
              field: "itemID",
              body: null,
              sortable: true,
              filter: true,
            },
            {
              header: "Item Type",
              field: "item.itemTypeName",
              body: (rowData) => (
                <React.Fragment>
                  <ResponsiveEllipsis
                    text={rowData.item.itemTypeName}
                    maxLine="1"
                  />
                </React.Fragment>
              ),
              sortable: true,
              filter: true,
              hidden: true,
            },
            {
              header: "Item Code",
              field: "item.itemCode",
              body: (rowData) => (
                <React.Fragment>
                  {rowData.item.itemType > 0 ? (
                    <span>
                      <BootstrapTooltip title={rowData.item.itemTypeName}>
                        <span className="mr-2">
                          <i
                            className={
                              rowData.item.itemType === 1
                                ? "fas fa-boxes text-success"
                                : rowData.item.itemType === 2
                                ? "fas fa-tools text-primary"
                                : rowData.item.itemType === 3
                                ? "fas fa-building text-info"
                                : rowData.item.itemType === 4
                                ? "fas fa-boxes text-warning"
                                : rowData.item.itemType === 5
                                ? "fas fa-boxes text-danger"
                                : null
                            }
                          ></i>
                        </span>
                      </BootstrapTooltip>
                      <span>
                        <ResponsiveEllipsis
                          text={rowData.item.itemCode}
                          maxLine="1"
                          displayInline
                        />
                      </span>
                    </span>
                  ) : (
                    <React.Fragment>
                      <ResponsiveEllipsis
                        text={rowData.item.itemCode}
                        maxLine="1"
                      />
                    </React.Fragment>
                  )}
                </React.Fragment>
              ),
              sortable: true,
              filter: true,
            },
            {
              header: "Item Name",
              field: "item.itemName",
              body: (rowData) => (
                <React.Fragment>
                  <ResponsiveEllipsis
                    text={rowData.item.itemName}
                    maxLine="1"
                  />
                </React.Fragment>
              ),
              sortable: true,
              filter: true,
            },
            {
              header: "Base Unit",
              field: "uomName",
              body: (rowData) => (
                <React.Fragment>
                  <ResponsiveEllipsis text={rowData.uomName} maxLine="1" />
                </React.Fragment>
              ),
              sortable: true,
              filter: true,
            },
            {
              header: "Outlet Price",
              field: "outletPrice",
              body: (rowData, option) => {
                const index = _.findIndex(values.data, (sellItem) => {
                  return sellItem.itemID === rowData.itemID;
                });
                return (
                  <FormArrayTextField
                    arrayPropName="data"
                    index={index}
                    propName="outletPrice"
                    margin="none"
                    value={rowData.outletPrice}
                    currencyField
                    currencyCode={outlet.currency.currencyCode}
                  />
                );
              },
              sortable: true,
              filter: true,
            },
            {
              header: "Actions",
              body: (rowData) => (
                <React.Fragment>
                  <BootstrapTooltip title="Alternative Variant Unit Prices">
                    <button
                      type="button"
                      onClick={() => {
                        setSelectedItem(rowData);
                        setOpenItemVariants(true);
                      }}
                      className="btn btn-icon btn-label-info btn-circle btn-md mx-1"
                    >
                      <i className="fas fa-coins"></i>
                    </button>
                  </BootstrapTooltip>
                </React.Fragment>
              ),
              sortable: false,
            },
          ]}
        />
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Sales.png"
            description="Hooray! You're ready to manage your product Outlet Selling Price!"
            guidance="Hint: manage your products inventory first before setup the Outlet Selling Price"
            descriptionLeftIcon="fas fa-info-circle kt-font-success"
            size="md"
          />
          <div className="text-center py-3">
            <button
              type="button"
              className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
              onClick={() => {
                history.push("/inventory/items");
              }}
            >
              <i className="fas fa-map-marker-alt"></i>
              Go To Item Inventory
            </button>
          </div>
        </React.Fragment>
      )}
      <DialogLayout
        open={openItemVariants}
        title={`Outlet Item Alternative Variant Unit Prices Form - ${selectedItem.item.itemCode} ${selectedItem.item.itemName}`}
        onCloseDialog={() => {
          setOpenItemVariants(false);
        }}
        maxWIdth="md"
      >
        <ItemSellVarDetailForm
          selectedItem={selectedItem}
          onConfirmSave={() => {
            setOpenItemVariants(false);
          }}
          onCloseDialog={() => {
            setOpenItemVariants(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );
}

export default ItemSellFormContent;
